'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useLayoutEffect, useRef } from 'react';

import { isGiftPagePath } from '@/lib/gift-page';

function scrollToTop() {
  window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

export const RouteTracker = () => {
  const pathname = usePathname();
  const lastPathname = useRef<string | null>(null);
  const isInitialLoadRef = useRef(true);

  useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    if (lastPathname.current !== null && lastPathname.current !== pathname) {
      scrollToTop();
    }
    lastPathname.current = pathname;
  }, [pathname]);

  useEffect(() => {
    // Its path is a gift card code: kept out of storage, and so out of every
    // Go back link.
    if (isGiftPagePath(pathname)) return;

    const prev = sessionStorage.getItem('currentUrl');
    // document.referrer doesn't update during SPA navigations, so only check
    // on initial page load to avoid permanently blocking prevUrl updates
    // after returning from an external site like Stripe.
    const cameFromExternal =
      isInitialLoadRef.current &&
      !!document.referrer &&
      !document.referrer.includes(location.origin);
    isInitialLoadRef.current = false;

    if (!cameFromExternal && prev && prev !== pathname) {
      sessionStorage.setItem('prevUrl', prev);
    }

    sessionStorage.setItem('currentUrl', pathname);
  }, [pathname]);

  return null;
};
